export default "__VITE_ASSET__533ee44e__"